import {useEffect, useState} from 'react';

import uwmMessageService from '@/services/uwm/uwmMessageService';

// The host menu starts hiding after 150ms and takes roughly as long to slide out of view.
const MENU_HIDE_DELAY_MS = 300;

let hideRequestCount = 0;

/** Hides the host menu while active; returns true once it is gone, so a layer can open after it. */
const useHideMenu = (active: boolean = true): boolean => {
    const [isMenuHidden, setIsMenuHidden] = useState(false);

    useEffect(() => {
        if (!active) return;

        hideRequestCount++;
        const isFirstRequest = hideRequestCount === 1;
        if (isFirstRequest) uwmMessageService.sendHideMenu();

        // A layer stacked on another one finds the menu already hidden.
        const timer = setTimeout(() => setIsMenuHidden(true), isFirstRequest ? MENU_HIDE_DELAY_MS : 0);

        return () => {
            clearTimeout(timer);
            setIsMenuHidden(false);
            hideRequestCount--;
            if (hideRequestCount === 0) uwmMessageService.sendShowMenu();
        };
    }, [active]);

    return active && isMenuHidden;
};

export default useHideMenu;
